import { useLocation, useNavigate } from 'react-router-dom';
import { Svgs } from '../../assets';
import styles from './style.module.scss';
import { useState } from 'react';
import Modal from '../Modal';

const MENU_LIST: { title: string; url: string }[] = [
  { title: 'ABOUT', url: '/about' },
  { title: 'ROOMS', url: '/rooms' },
  { title: 'CONTACT', url: '/contact' }
];

export default function Component({
  isBackground = true
}: {
  isBackground?: boolean;
}) {
  const navigation = useNavigate();
  const location = useLocation();
  const [isSideMenu, setIsSideMenu] = useState(false);

  return (
    <>
      <div
        className={[styles.container, !!isBackground && styles.background].join(
          ' '
        )}
      >
        <div className={styles.logo} onClick={() => navigation('/')}>
          <Svgs.Logo />
        </div>

        <div className={styles.menuList}>
          {MENU_LIST.map((item) => {
            const isActive = location.pathname === item.url;
            return (
              <div
                key={item.url}
                onClick={() => navigation(item.url)}
                className={[styles.menu, isActive && styles.active].join(' ')}
              >
                {item.title}
              </div>
            );
          })}
        </div>

        <div className={styles.menuBar} onClick={() => setIsSideMenu(true)}>
          <Svgs.Menu width={22} />
        </div>
      </div>
      <SideMenu visible={isSideMenu} close={() => setIsSideMenu(false)} />
    </>
  );
}

function SideMenu({
  visible,
  close
}: {
  visible: boolean;
  close?: () => void;
}) {
  const navigation = useNavigate();
  const location = useLocation();

  return (
    <Modal
      visible={visible}
      backOpacity={30}
      contentClassName={styles.sideMenu}
      close={close}
      toWay="right"
      position={{ top: 0, bottom: 0, right: 0 }}
    >
      <div className={styles.menuList}>
        {MENU_LIST.map((item) => {
          const isActive = location.pathname === item.url;
          return (
            <div
              key={item.url}
              onClick={() => navigation(item.url)}
              className={[styles.menu, isActive && styles.active].join(' ')}
            >
              {item.title}
            </div>
          );
        })}
      </div>
    </Modal>
  );
}
